export default __webpack_public_path__ + "static/media/mobile.616716d6.svg";